import { ChangeDetectorRef, Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@aptsi-types';
import { PlatformService } from '../platform.service';
import { MatDialog } from '@angular/material/dialog';
import { SuccessDialogComponent } from 'src/app/shared/dialogs/success-dialog/success-dialog.component';
import { ErrorDialogComponent } from 'src/app/shared/dialogs/error-dialog/error-dialog.component';
import { KeycloakStateService } from 'src/app/core/service/utility.service';
import { ZoneService } from '../../zone/zone.service';

@Component({
  selector: 'app-platform-create-or-update',
  templateUrl: './platform-create-or-update.component.html',
  styleUrls: ['./platform-create-or-update.component.scss']
})
export class PlatformCreateOrUpdateComponent {
 isCreate = false;
  existingPlatformId: string = null;
  platform: Platform = null;
  variables: string[] = [];
  filteredVariables: string[] = [];
  organizationId: string;
  form: FormGroup;
 
  readonly categories= ['Cloud', 'On-Premises', 'SaaS', 'Hybrid', 'None'];

  // ─────────────────────────────
  // Lifecycle
  // ─────────────────────────────
  constructor(
    private route: ActivatedRoute,
    private platformService: PlatformService,
    private dialog: MatDialog,
    private router: Router,
    private zoneService: ZoneService,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit(): Promise<void> {
    console.log("Organization ID in component:", this.organizationId);
    this.isCreate = Boolean(this.route.snapshot.data.create);
    this.existingPlatformId = this.route.snapshot.params.platformId;
    

    
    if (!this.isCreate) {
      this.fetchPlatform();
    }

     

    this.form = this.isCreate
      ? new FormGroup({
          platformId: new FormControl(null),
          platformName: new FormControl(null, Validators.required),
          category: new FormControl( 'None', [Validators.required, this.typeValidator]),
          description: new FormControl(null, Validators.required),
         
        })
      : new FormGroup({
          platformId: new FormControl(this.existingPlatformId, Validators.required),
          platformName: new FormControl(
            this.platform?.name || null,
            Validators.required
          ),
          category: new FormControl(this.platform?.category || 'None', [Validators.required, this.typeValidator]),
          description: new FormControl(
            this.platform?.description || null,
            Validators.required
          ),
        });

  }




  // ─────────────────────────────
  // Data Fetching
  // ─────────────────────────────
  async fetchPlatform() {
    try {
      const response = await this.platformService
        .getPlatform(this.existingPlatformId)
        .toPromise();
      this.platform = response['Resource retrieved successfully']?.[0];

      console.log("Fetched Platform:", this.platform);

      if (this.platform) {
        this.form.patchValue({
          platformName: this.platform.name,
          category: this.platform.category,
          description: this.platform.description,
        });
      }
    } catch (error) {
      console.error("Error fetching rules:", error);
    }
  }

  // ─────────────────────────────
  // Validation
  // ─────────────────────────────
  typeValidator(control: AbstractControl): { [key: string]: any } | null {
    return control.value === "None" ? { noneSelected: true } : null;
  }

  // ─────────────────────────────
  // Submit Logic
  // ─────────────────────────────
  async submit() {
    try {
      if (this.isCreate) {
        let res = await this.platformService
          .createPlatform(
            this.form.value.platformName,           
            this.form.value.description,
            this.form.value.category
          )
          .toPromise();

        
          this.openSuccessDialog(this.isCreate);
       
      } else {
        await this.platformService
          .updatePlatform(
            this.form.value.platformId,
            this.form.value.platformName,
            this.form.value.description,
            this.form.value.category,
          )
          .toPromise();

        this.openSuccessDialog(this.isCreate);
      }
    } catch (error) {
      this.openErrorDialog(error.message || "An unexpected error occurred.");
    }
  }

  // ─────────────────────────────
  // Navigation
  // ─────────────────────────────
  cancel() {
    this.router.navigate(["secure-zone/platform/search"]);
  }

  // ─────────────────────────────
  // Dialogs
  // ─────────────────────────────
  openSuccessDialog(isCreate: boolean): void {
    this.dialog
      .open(SuccessDialogComponent, {
        width: "250px",
        data: { isCreate: isCreate, isCreateUpdate: true, title: "Platform" },
      })
      .afterClosed()
      .subscribe(() => {
        this.router.navigate(["secure-zone/platform/search"]);
      });
  }


  openErrorDialog(errorMessage: string): void {
    this.dialog.open(ErrorDialogComponent, {
      width: "250px",
      data: { errorMessage },
    });
  }
}
